"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var useStyles = (0, styles_1.makeStyles)(function (_a) {
    var spacing = _a.spacing;
    return ({
        container: {
            paddingLeft: spacing(1.25),
            paddingRight: spacing(1.25)
        }
    });
});
exports.default = useStyles;
